import type { CSSProperties } from 'react';
import styled from 'styled-components';

interface AvatarProps {
  character: string;
  size: number;
  color: string;
  fontSize: string;
  style?: CSSProperties;
}

const Avatar = ({ character, size, color, fontSize, style }: AvatarProps) => {
  return (
    <Wrapper size={size} color={color} fontSize={fontSize} style={style}>
      {character}
    </Wrapper>
  );
};

export default Avatar;

export const Wrapper = styled.div<{
  size: number;
  color: string;
  fontSize: string;
  customStyle?: string;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  color: white;
  font-weight: 300;
  line-height: 0;
  ${({ fontSize }) => `font-size: ${fontSize}`};
  ${({ color }) => `background-color: ${color}`};
`;
